<template>
  <div class="dashboard-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>系统概览</span>
      </div>
      
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-state">
        <el-loading-spinner size="large"></el-loading-spinner>
        <p>加载中...</p>
      </div>
      
      <!-- 错误状态 -->
      <div v-if="error" class="error-state">
        <i class="el-icon-error"></i>
        <p>{{ error }}</p>
        <el-button type="primary" @click="loadData">重试</el-button>
      </div>
      
      <!-- 统计数据 -->
      <div v-if="!loading && !error" class="stats-container">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-card class="stat-card">
              <div class="stat-content">
                <div class="stat-number">{{ stats.workCount || 0 }}</div>
                <div class="stat-label">作品总数</div>
              </div>
              <div class="stat-icon">
                <i class="el-icon-folder"></i>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="stat-card">
              <div class="stat-content">
                <div class="stat-number">{{ stats.roleCount || 0 }}</div>
                <div class="stat-label">角色总数</div>
              </div>
              <div class="stat-icon">
                <i class="el-icon-user"></i>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="stat-card">
              <div class="stat-content">
                <div class="stat-number">{{ stats.tagCount || 0 }}</div>
                <div class="stat-label">标签总数</div>
              </div>
              <div class="stat-icon">
                <i class="el-icon-tags"></i>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      
      <!-- 最近活动 -->
      <div v-if="!loading && !error" class="recent-activity">
        <h3>最近活动</h3>
        <el-timeline>
          <el-timeline-item 
            v-for="activity in activities" 
            :key="activity.id"
            :timestamp="activity.time" 
            placement="top">
            {{ activity.content }}
          </el-timeline-item>
          <el-timeline-item v-if="activities.length === 0" placement="top">
            暂无活动记录
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getDashboardStats, getRecentActivities } from '@/api/dashboard';

export default {
  name: 'DashboardView',
  data() {
    return {
      stats: {},
      activities: [],
      loading: true,
      error: ''
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      this.error = '';
      
      try {
        // 并行请求数据
        const [statsResponse, activitiesResponse] = await Promise.all([
          getDashboardStats(),
          getRecentActivities()
        ]);
        
        this.stats = statsResponse.data.data;
        this.activities = activitiesResponse.data.data;
      } catch (err) {
        this.error = '加载数据失败，请重试';
        console.error('Dashboard数据加载失败:', err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.stats-container {
  margin-bottom: 30px;
}

.stat-card {
  position: relative;
  overflow: hidden;
}

.stat-content {
  padding: 15px;
}

.stat-number {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 5px;
}

.stat-label {
  color: #889099;
}

.stat-icon {
  position: absolute;
  top: 0;
  right: 0;
  width: 60px;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #409eff;
}

.recent-activity {
  margin-top: 20px;
}

.recent-activity h3 {
  margin-bottom: 15px;
}

.loading-state {
  text-align: center;
  padding: 50px 0;
}

.loading-state p {
  margin-top: 10px;
  color: #889099;
}

.error-state {
  text-align: center;
  padding: 50px 0;
  color: #f56c6c;
}

.error-state i {
  font-size: 48px;
  margin-bottom: 10px;
}
</style>